import React, { useEffect, useState } from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { useTheme } from "../context/ThemeContext";

const POLICY_ID = "UkN0SVFtSmFhR1JXZDFob2RXYzlQUT09";

const Eula: React.FC = () => {
  const { isDarkMode } = useTheme();
  const [policyHtml, setPolicyHtml] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`https://policies.termageddon.com/api/policy/${POLICY_ID}?render`)
      .then((res) => res.text())
      .then((html) => setPolicyHtml(html))
      .catch(() => setError(true));
  }, []);

  return (
    <div className={`min-h-screen flex flex-col ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <Navbar />

      <div className="flex-1 py-8 sm:py-16 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h1 className={`text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
              End User License Agreement
            </h1>
          </div>

          <div className={`rounded-lg shadow-md p-6 sm:p-8 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
            {policyHtml ? (
              <div
                className={`prose max-w-none ${isDarkMode ? 'text-gray-300 prose-headings:text-white prose-a:text-blue-400' : 'text-gray-700'}`}
                dangerouslySetInnerHTML={{ __html: policyHtml }}
              />
            ) : error ? (
              <p className={`text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Unable to load the policy. Please{" "}
                <a
                  rel="nofollow noreferrer"
                  href={`https://policies.termageddon.com/api/policy/${POLICY_ID}`}
                  target="_blank"
                  className="text-blue-500 hover:underline"
                >
                  click here
                </a>{" "}
                to view the policy.
              </p>
            ) : (
              <p className={`text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Loading policy...</p>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Eula;
